import { Autocomplete, Grid, TextField } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { Version } from '@helpers/types';
import { useHttp } from '@hooks/use-http.ts';

interface IVersionSelectorProps {
  value: Version | null;
  station: string;
  country: string;
  onChange: (v: Version) => void;
}

const VersionSelector = (props: IVersionSelectorProps) => {
  const http = useHttp();
  const [versions, setVersions] = useState<Array<Version>>([]);
  const onChangeVersion = useCallback(
    (_: any, value: Version) => props.onChange(value),
    [props],
  );

  useEffect(() => {
    if (!props.country || !props.station) {
      return;
    }

    http.lastmile.getVersions(props.country, props.station, false)
      .then((versions) => {
        setVersions(versions);
      })
      .catch((err) => {
        console.error('VersionSelector - Error loading versions:', err);
      });
  }, [props.station, props.country, http]);

  return (
    <Grid size={{ xs: 12 }}>
      <Autocomplete
        size="small"
        value={props.value ?? undefined}
        onChange={onChangeVersion}
        disableClearable={true}
        getOptionLabel={(option) => option?.version}
        renderOption={(props, option, _) => (
          <li {...props}>{option?.version}</li>
        )}
        isOptionEqualToValue={(option, value) => {
          return option?._id === value?._id;
        }}
        options={versions}
        renderInput={(params) => (
          <TextField {...params} variant="outlined" label="Version de zonas" />
        )}
      />
    </Grid>
  );
};
export default VersionSelector;